import React, { memo, forwardRef, useContext, useMemo } from 'react';
import cn from 'classnames';
import { useCalendarGrid } from '@react-aria/calendar';
import { getWeeksInMonth, startOfWeek, today } from '@internationalized/date';
import { useDateFormatter } from '@react-aria/i18n';
import { CalendarCell } from './CalendarCell';
import { CalendarContext } from './contexts';
import styles from './styles.module.css';
import { Typography } from '../typography';
export const CalendarGrid = memo(forwardRef(function CalendarGrid(props, ref) {
    const context = useContext(CalendarContext);
    if (!context) {
        throw new Error('');
    }
    const { state, locale } = context;
    const { gridProps, headerProps } = useCalendarGrid(props, state);
    const dayFormatter = useDateFormatter({ weekday: 'short', timeZone: state.timeZone });
    const weekDays = useMemo(() => {
        const weekStart = startOfWeek(today(state.timeZone), locale);
        return Array.from({ length: 7 }, (_, index) => dayFormatter.format(weekStart.add({ days: index }).toDate(state.timeZone)));
    }, [locale, state.timeZone, dayFormatter]);
    const { className, startDate, endDate, ...rest } = props;
    const month = startDate || state.visibleRange.start;
    // Get the number of weeks in the month so we can render the proper number of rows.
    const weeksInMonth = getWeeksInMonth(month, locale);
    return (React.createElement("table", { ...gridProps, ...rest, className: cn(styles.grid, className), ref: ref },
        React.createElement("thead", { ...headerProps },
            React.createElement("tr", null, weekDays.map((day, index) => (React.createElement(Typography, { className: cn(styles.cell, styles.head), variant: "caption1", color: "minor", Component: "th", key: index }, day))))),
        React.createElement("tbody", null, [...new Array(weeksInMonth).keys()].map(weekIndex => (React.createElement("tr", { key: weekIndex }, state
            .getDatesInWeek(weekIndex, startDate)
            .map((date, i) => date ? React.createElement(CalendarCell, { key: i, date: date, currentMonth: month }) : React.createElement("td", { key: i }))))))));
}));
